import React, { useState } from "react";
import { classNames, findDataInFields } from "../../utils/helperFuctions";
import PopUp from "../PopUp/PopUp";
import { getCookie } from "../../utils/cookieHandler";

export default function Tabs({
  tabsData,
  tabChanged,
  handleSubmit,
  currentFields,
  renderRight,
}) {
  const isTabLocked = (tab) => {
    const admin = process.env.REACT_APP_ADMIN_ROLE;
    const currentRole1 = getCookie("_r");
    const isAdmin = currentRole1 === admin;
    if (isAdmin) {
      return { isLocked: false, matchedCondition: null };
    }
    if (!Array.isArray(tab.lockIfFieldValue)) {
      return { isLocked: false, matchedCondition: null };
    }

    for (const condition of tab.lockIfFieldValue) {
      const fieldValue = findDataInFields(currentFields, condition.field, true);

      if (fieldValue === condition.value || fieldValue == condition.value) {
        return {
          isLocked: true,
          matchedCondition: condition,
        };
      }
    }

    return {
      locked: false,
      matchedCondition: null,
    };
  };

  const [tabs, setTabs] = useState(tabsData);
  const [popupData, setpopupData] = useState({});

  const handleTabChange = async (selectedTabName) => {
    const updatedTabs = tabs.map((tab) => ({
      ...tab,
      current: tab.name === selectedTabName,
    }));
    const res = await handleSubmit();

    if (res !== false && res != null) {
      setTabs(updatedTabs);
      tabChanged(updatedTabs.find((obj) => obj.current === true));
    }
  };

  if (!tabs || tabs.length <= 0) return <></>;

  return (
    <div className="pb-5">
      <div className="sm:hidden">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to update the current tab. */}
        <select
          id="tabs"
          name="tabs"
          className="hidden w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
          value={tabs.find((tab) => tab.current)?.name}
          onChange={(e) => handleTabChange(e.target.value)}
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.name}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="block">
        <div className="border-b border-gray-200">
          <div className="flex items-center justify-between">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              {tabs.map((tab) => {
                const { isLocked, matchedCondition } = isTabLocked(tab);
                return (
                  <button
                    key={tab.name}
                    href={tab.href}
                    // disabled={isLocked}
                    className={classNames(
                      tab.current
                        ? "border-blue-500 text-primary"
                        : isLocked
                        ? "border-transparent text-gray-400 cursor-not-allowed opacity-50"
                        : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
                      "whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium"
                    )}
                    aria-current={tab.current ? "page" : undefined}
                    onClick={() => {
                      // const clickedTab = tab.lockIfFieldValue[ta]
                      if (isLocked === true) {
                        setpopupData({
                          title: "Cannot proceed",
                          description: matchedCondition.message,
                          showPopUp: true,
                          hideCancel: true,
                        });
                        return;
                      }
                      handleTabChange(tab.name);
                    }}
                  >
                    {tab.name}
                  </button>
                );
              })}
            </nav>
            {typeof renderRight === "function" && (
              <div className="py-2">
                {renderRight(tabs.find((t) => t.current))}
              </div>
            )}
          </div>
        </div>
      </div>
      <PopUp
        onSuccess={popupData.onSuccess}
        isError={popupData.isError}
        title={popupData.title}
        description={popupData.description}
        formOptions={popupData.formOptions}
        takeActionText={popupData.takeActionText}
        takeActionFun={popupData.takeActionFun}
        showPopUp={popupData.showPopUp}
        hidePopUp={() => {
          setpopupData({});
        }}
        formSubmit={popupData.formSubmit}
        formConcatData={popupData.formConcatData}
        propName={popupData.propName}
        disabledForm={popupData.disabledForm}
        hideCancel={popupData.hideCancel}
        hideMainButton={popupData.hideMainButton}
        showLoading={popupData.hideMainButton}
        progressValue={popupData.progressValue}
      >
        {popupData.children}
      </PopUp>
    </div>
  );
}
